import { QuizService } from "app/services";
import { QuizType } from "app/types";

const quizCache = {} as Record<number, string>;

export const useResultsModel = (quizService: QuizService) => {
  const getQuizNameById = async (quizId: number): Promise<string> => {
    try {
      if (!quizId) {
        throw new Error();
      }
      if (quizCache?.[quizId]) {
        return quizCache[quizId];
      }
      const result: QuizType = await quizService.get(quizId);
      quizCache[quizId] = result?.name || "";
      return quizCache[quizId];
    } catch (error) {
      console.warn("Erro ao buscar nome do quiz com id: ", quizId);
      return "";
    }
  };

  return {
    getQuizNameById,
  };
};
